export enum UpgradePlanAction {
  Request = 'request'
}

export enum Industry {
  default = 'Industry',
  consulting = 'Consulting & Professional Services',
  energy = 'Energy & Utilities',
  events_entertainment = 'Events and Entertainment',
  finance = 'Financial Services	',
  government_non_profit = 'Government & Non-profit',
  healthcare = 'Healthcare',
  hospitality = 'Hospitality & Real Estate',
  transport_shipping_logistics = 'Transportation, Shipping & Logistics',
  manufacturing = 'Manufacturing',
  media = 'Media',
  oil_gas_mining = 'Oil & Gas, Mining',
  pharmaceuticals = 'Pharmaceuticals',
  retail = 'Retail & eCommerce',
  technology = 'Technology',
  telecommunications = 'Telecommunications'
}

export type IndustryKey = keyof typeof Industry;
export type ReasonKey = keyof typeof Reason;

export const EmployeeRangeOptions = [
  {
    label: 'No. of employees',
    value: -1
  },
  {
    label: '1-50',
    value: 25
  },
  {
    label: '50-100',
    value: 50
  },
  {
    label: '100-200',
    value: 100
  },
  {
    label: '200-500',
    value: 200
  },
  {
    label: 'More than 500',
    value: 500
  }
];

export enum Reason {
  default = 'Reason for choosing us',
  employee_meal_programs = 'Employee Meal Programs',
  events_catering_large_orders = 'Events, Catering & Large Orders',
  rewards_recognition_gifts = 'Rewards, Recognition & Gifts',
  pantry_supplies = 'Pantry & Supplies',
  employee_perks = 'Employee Perks'
}

export type DropdownOptions = {
  industries: IndustryKey[];
  reasons: ReasonKey[];
};
